import type { ActionMetaInfo } from '../schema/ActionMetaInfo';
import { AppContext } from '../schema/AppContext';
import { createAppContext } from './createAppContext';

/**
 * Decorator to wrap the callbacks or actions with their metadata, which can
 * then be used by the registered middlewares.
 */
/* eslint-disable-next-line @typescript-eslint/no-explicit-any --
 * See aka.ms/mini-lint-errors
 *	> Unexpected any. Specify a different type.
 *	> Unexpected any. Specify a different type.
 *	> Unexpected any. Specify a different type. */
export function appAction(target: any, metaInfo: ActionMetaInfo): (...args: any[]) => any {
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    let next: any;

    if (!target) {
        next = () => {};
    } else if (typeof target !== 'function') {
        throw new Error("'appAction' can only be used on top of functions");
    } else {
        next = (metaInfo, ctx, ...args) => {
            try {
                return target(...args, ctx);
            } catch {
                return target(...args);
            }
        };
    }

    next = AppContext.middlewares.reduceRight(
        (next, middleware) => applyNextMiddleware(middleware, next),
        next
    );

    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    return (...args: any[]) => {
        const ctx: AppContext = createAppContext();
        metaInfo.customData = { ...metaInfo.customData, cId: ctx.correlationId };
        return next({ ...metaInfo }, ctx, ...args);
    };
}

/* eslint-disable-next-line @typescript-eslint/no-explicit-any --
 * See aka.ms/mini-lint-errors
 *	> Unexpected any. Specify a different type.
 *	> Unexpected any. Specify a different type.
 *	> Unexpected any. Specify a different type. */
function applyNextMiddleware(middleware: any, next: any): any {
    return middleware.bind(null, next);
}
